import { withTranslation } from "@template/components/translation";
import NewsletterSignupForm from "./NewsletterSignupForm";

export default withTranslation(NewsletterSignupForm);
